import React, { useState, useEffect } from 'react';
import { useGame } from '../context/GameContext.jsx';

const SolveScreen = () => {
  const {
    translations,
    lang,
    isLoading,
    availableSolutionCards,
    selectedSolutionCards,
    setSelectedSolutionCards,
    submitSolution,
    showToastMessage,
    uiTheme
  } = useGame();

  const handleToggleChange = (cardId) => {
    setSelectedSolutionCards(prevSelectedCards => ({
      ...prevSelectedCards,
      [cardId]: !prevSelectedCards[cardId]
    }));
  };

  const getCategoryLabel = (categoryType) => {
    switch (categoryType) {
      case 'P': return translations[lang]?.people_label || 'Pessoas';
      case 'L': return translations[lang]?.places_label || 'Lugares';
      case 'E': return translations[lang]?.evidence_label || 'Evidências';
      default: return 'Outros';
    }
  };

  const getButtonClass = (cardId, isSelected) => {
    const type = cardId.charAt(0).toUpperCase();
    let baseClass = 'btn w-100 text-start d-flex align-items-center mb-2 rounded solution-card-button';
    let colorClass = '';

    switch (type) {
      case 'P': colorClass = isSelected ? 'btn-danger' : 'btn-outline-danger'; break;
      case 'E': colorClass = isSelected ? 'btn-info' : 'btn-outline-info'; break;
      case 'L': colorClass = isSelected ? 'btn-success' : 'btn-outline-success'; break;
      default: colorClass = isSelected ? 'btn-secondary' : 'btn-outline-secondary'; break;
    }
    return `${baseClass} ${colorClass}`;
  };

  const getBadgeClass = (cardId) => {
    const type = cardId.charAt(0).toUpperCase();
    switch (type) {
      case 'P': return 'bg-danger';
      case 'E': return 'bg-info';
      case 'L': return 'bg-success';
      default: return 'bg-secondary';
    }
  };

  const groupedCards = Object.entries(availableSolutionCards).reduce((acc, [cardId, cardTitle]) => {
    const category = cardId.charAt(0).toUpperCase();
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push({ cardId, cardTitle });
    return acc;
  }, {});

  const categoryOrder = ['P', 'L', 'E'];

  const handleSubmitSolution = () => {
    const selectedCardIds = Object.keys(selectedSolutionCards).filter(cardId => selectedSolutionCards[cardId]);

    if (selectedCardIds.length === 0) {
      showToastMessage(translations[lang]?.no_hypothesis_selected_toast);
      return;
    }
    
    submitSolution(selectedCardIds);
  };

  if (isLoading && Object.keys(availableSolutionCards).length === 0) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">{translations[lang]?.loading_text}</span>
        </div>
        <p className="text-light mt-3">{translations[lang]?.loading_text}</p>
      </div>
    );
  }

  const accordionItemClass = uiTheme === 'fantasy' ? 'accordion-item-fantasy' : 'bg-dark border-secondary';
  const accordionButtonClass = uiTheme === 'fantasy' ? 'accordion-button-fantasy' : 'bg-dark text-light';

  return (
    <div className="screen-content d-flex flex-column align-items-center p-3">
      <h3 className="text-light text-center mb-3 fs-6">{translations[lang]?.solve_screen_instruction}</h3>

      <div className="accordion w-100 mb-4" id="solutionAccordion" style={{ maxWidth: '400px' }}>
        {categoryOrder.map((category) => (
          groupedCards[category] && groupedCards[category].length > 0 && (
            <div className={`accordion-item ${accordionItemClass}`} key={category}>
              <h2 className="accordion-header" id={`heading${category}`}>
                <button
                  className={`accordion-button collapsed ${accordionButtonClass}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${category}`}
                  aria-expanded="false"
                  aria-controls={`collapse${category}`}
                >
                  {getCategoryLabel(category)}
                </button>
              </h2>
              <div
                id={`collapse${category}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading${category}`}
                data-bs-parent="#solutionAccordion"
              >
                <div className="accordion-body">
                  {groupedCards[category].map((card) => (
                    <button
                      key={card.cardId}
                      className={getButtonClass(card.cardId, !!selectedSolutionCards[card.cardId])}
                      onClick={() => handleToggleChange(card.cardId)}
                    >
                      <span className={`badge ${getBadgeClass(card.cardId)} me-2`}>{card.cardId.substring(1)}</span>
                      <span className="text-start flex-grow-1">{card.cardTitle}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )
        ))}
      </div>

      <button
        className="btn btn-primary btn-lg initial-screen-button"
        onClick={handleSubmitSolution}
        disabled={isLoading}
      >
        {translations[lang]?.solve_submit_button}
      </button>
    </div>
  );
};

export default SolveScreen;
